module.exports = __webpack_public_path__ + "img/table-down.4e784519.svg";